import { localGql } from '../../data/gql-gen/local'

export const AUDIENCE_CHANGED_SINCE_LAST_SLACK_IRS_NOTIFICATION_QUERY =
  localGql(/* GraphQL */ `
    query audienceChangedSinceLastSlackIRSNotificationQuery {
      audienceChangedSinceLastIRSNotification @client
    }
  `)
